function refreshMiniCart(){
        $('#select-gift-modal').modal('hide');
        setTimeout(function(){ ajaxRefreshMiniCartPage();},0);
        $.ajax({dataType:"json",url:"/cart.json"+"?"+(new Date().getTime()),async:1,cache:!1,
                
                success:function(e){
                //check cart
                var retain = null;
                var removeList = [];
                var freeGift= false;
                var needUpdate = false;
                var handleList = [];
                $.each(e.items, (function(e, t) {


                    if(t.price <=0){
                        if (retain != null){
                            removeList.push(t.id)
                        }else{
                            //check quantity
                            if(t.quantity == 1){
                                retain = t.id;
                            }else{
                                retain = t.id;
                                needUpdate = true;
                            }
                        }
                        freeGift = true;

                    }
                  handleList.push(t.handle);
                }));


                if(needUpdate || removeList.length > 0){

                    $.each(removeList, (function(e, t) {



                        $.ajax(
                            {type: "POST",
                             async:1,
                             cache:!1,
                                url: "/cart/change.js",
                                data: "quantity=" + 0 + "&id=" + t,
                                dataType: "json",
                                success: function(e) {


                                },
                                error: function(e, t) {

                                }
                            }
                        )


                    }));
                    if(needUpdate){

                        $.ajax(
                            {type: "POST",
                             async:1,
                             cache:!1,
                                url: "/cart/change.js",
                                data: "quantity=" + 1 + "&id=" + retain,
                                dataType: "json",
                                success: function(e) {

                                },
                                error: function(e, t) {

                                }
                            }
                        )
                    }

                    return refreshMiniCart();
                }

                //check conguralation


                

                if(e.original_total_price>20000){
                  
                  $(".mini-cart-card .mini-cart__summary__links__link").attr("href",'/checkout?discount=SP30');
                  $('.mini-cart-card .mini-cart__footer__promotion__product span').html('Get an Additional <span style="color:#496f5d">30%</span> Off w/ code: <span style="color:#496f5d">SP30</span>')
                }else{
                  $(".mini-cart-card .mini-cart__summary__links__link").attr("href",'/checkout?discount=SP20');
                  $('.mini-cart-card .mini-cart__footer__promotion__product span').html('Get an Additional <span style="color:black">20%</span> Off w/ code: <span style="color:black">SP20</span>')
                }

                if(e.original_total_price >= 3000 && e.original_total_price <= 10000){
                    $('.mini-cart-card .show-str').html('<span>You Have Got Free Shipping (5-7 Days)</span>')
                }else if(e.original_total_price>10000 && e.original_total_price<20000){
                    $('.mini-cart-card .show-str').html('<span>Just a little bit away from getting 30% Off(over $200)</span>')
                }else if(e.original_total_price >= 20000 && e.original_total_price < 28600){
                    $('.mini-cart-card .show-str').html('<span>Congratulations on got 30% off!</span>')
                }else if(e.original_total_price >= 28600){
                    $('.mini-cart-card .show-str').html('<span>You Have Got Free DHL Express (3-5 Days)</span>')
                }else{
                    $('.mini-cart-card .show-str').html('')
                }

                
                // $('#cart-modal .modal-table').empty();
                $('.mini-cart-card .mini-cart__summary__title').text('Cart ('+e.item_count+'):');
                $('.mini-cart-card .minicart-select-gift').hide();
                $('.mini-cart-card .minicart-show-good-job').hide();
                if(freeGift == true){
                  
                    if(e.original_total_price>3000){
                        $('.mini-cart-card .minicart-show-good-job span').text('You earned a FREE Chain + FREE SHIPPING!');
                    }else{
                        $('.mini-cart-card .minicart-show-good-job span').text('You earned a FREE Chain!');
                    }
                   $('.mini-cart-card .minicart-show-good-job').show();

                }else{
                  
                    $('.mini-cart-card .minicart-select-gift').show()
                }
var codepercent=1;

                if(e.original_total_price>20000){
                    codepercent = 0.7
                  
                  }else{
                    codepercent = 0.8
                    
                  }
                  $(".mini-cart-card .mini-cart__summary__total-price span").html("$"+(e.original_total_price/100).toFixed(2));
                  $(".mini-cart-card .minicart-original-price .minicart-codeprice-badge span").html("$"+(e.original_total_price*codepercent/100).toFixed(2));
          
        var progressWidth = "0%";
        if(e.original_total_price < 3000){
        	progressWidth = "20%";
        }else if(e.original_total_price < 10000){
        	progressWidth = "45%";
        }else if(e.original_total_price < 15000){
        	progressWidth = "50%";
        }else if(e.original_total_price < 20000){
        	progressWidth = "55%";
        }else if(e.original_total_price < 28600){
        	progressWidth = "85%";
        }else{
        	progressWidth = "100%";
        }

                  $(".minicart-progress_inner").css("width",progressWidth);
                  if(window.innerWidth <=749){
                    setTimeout(function(){ minicartGetRecommend(handleList);},1);
                  }
          // ajaxRefreshMiniCartPage();
                 
                    
          return;
                
           
            }
               ,
                error: function(e, t) {
                  setTimeout(function(){ minicartRemoveMask();},1);
                  // $(".self-loading").hide();
                }})
    }
    function ajaxRefreshMiniCartPage(){
      
      fetch('/cart?view=minicart'+"&_"+(new Date().getTime()), {
          "credentials": "same-origin",
          "headers": {
              "cache-control": "no-cache"
          }
      })
          .then(function(response) {
              return response.text();
          }).then(function(data) {
          	var minicarthtml = data.split('#################');
          $('.mini-cart-card .mini-cart__items').html(minicarthtml[0]);
           // $('.mini-cart-card .mini-cart__summary__bnpl').html(minicarthtml[1]);
            setTimeout(function(){ minicartRemoveMask();},1);
            
       
      })
  }
  function startOpenMiniCart(){
    refreshMiniCart();
    minicartOpen();
  }
  function minicartOpen(){
   
    var currentTop = $(window).scrollTop();
     $("body").attr('data-ctop', currentTop);
    $("body").addClass("minicart-open");
    $("html").addClass("minicart-lock-html");
    $(".mini-cart-card-wrapper").addClass("open");
        try{
            if ( typeof (eval(pplr_w_h)) == "function" ){
                pplr_w_h()
            }

        }catch(e){

        }
  }
  function minicartClose(){
    $("html").removeClass("minicart-lock-html");
    $("body").removeClass("minicart-open");
    $(".mini-cart-card-wrapper").removeClass("open");
    
    if($("#shopify-section-product-recommendations").length > 0){
      $('html').animate({ scrollTop: $('#shopify-section-product-recommendations').offset().top-150 }, 1000);
    }else{
      $(window).scrollTop($("body").data("ctop"));
    }
    
     $("body").removeAttr('data-ctop');
    
  }

  $(document).on("click",".mini-cart-card__header__close-button",function(e){
        minicartClose();
    })

  function minicartAddMask(){
    $(".minicart-need-mask").addClass("minicart-loading-mask");
  }
  function minicartRemoveMask(){
    $(".minicart-need-mask").removeClass("minicart-loading-mask");
  }
  function minicartChangeCartQty(cartid,qty){
        $.ajax(
            {type: "POST",
                url: "/cart/change.js",
             	async:1,
             	cache:!1,
                data: "quantity=" + qty + "&id=" + cartid,
                dataType: "json",
                beforeSend: function() {
                  setTimeout(function(){ minicartAddMask();},1);
				},
             	
                success: function(e) {
                    refreshMiniCart();
                  
                },
                error: function(e, t) {
                 setTimeout(function(){ refreshMiniCart();minicartRemoveMask();},1);
                }
            }
        )
    }

    function minicartGetRecommend(cartHandleList){

        var guuUrl = "https://app.theguushop.com/getCartAlsoBuy";
         $.ajax(
              {type: "POST",
                  url: guuUrl,
               contentType: 'application/json',
               	async:1,
               	cache:!1,
                  data: JSON.stringify({"cart_handles":cartHandleList}),
                  dataType: "json",
                  success: function(e) {
                    if(e instanceof Array && e.length > 0){
                      var Queryitems = e.toString();
                      minicartGetRecommendPageRender(Queryitems);
                    
                    }
                  },
                  error: function(e, t) {
                   
                  }
              }
          )
      
    }

    function minicartGetRecommendPageRender(queryItem){
      fetch('/cart?view=rcmd&pid='+queryItem, {
          "credentials": "same-origin",
          "headers": {
              "cache-control": "no-cache"
          }
      })
          .then(function(response) {
              return response.text();
          }).then(function(content) {
            if( $(".mini-cart-card .mini-cart__content .mini-cart-also-buy").length > 0 ){
              	$(".mini-cart-card .mini-cart__content .mini-cart-also-buy").replaceWith(content)
            }else{
            	$(".mini-cart-card .mini-cart__content").append(content)
            }
      })
    }
    
  function checkIfShowMiniCart(){
    return false;
    // return true;
    // var showMiniCartIpLast = ["0","1","2","3","4"];
    // var showMiniCartIpLast = ["5","6","7","8","9"];
    if(typeof startOpenMiniCart === 'function' ){
         var guuabtestStamped = getCookie("guu-abtest-stamped");
          if(guuabtestStamped.length > 0 && guuabtestStamped > 49 && guuabtestStamped < 70){
             return true;
          }else{
            return false;
          }
         
    }else{
      return false;
    }
  }
//   $(document).on("click",".mini-cart-card-wrapper:not(.mini-cart-card)",function(e){
//        console.log('need close')
//     })
// $(document).on("click",".mini-cart-card",function(e){
//        e.stopPropagation()
// })
    $(document).on("click",".minicart-qty-btn-plus",function(e){
        $(this).attr("disabled","true");
        var cartid = $(this).data('itemid');
        // Stop acting like a button
        e.preventDefault();
        var parentD = $(this).parent()

        // Get the field name
        // Get its current value
        var currentVal = parseInt(parentD.find('input').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            minicartChangeCartQty(cartid,currentVal + 1)
            parentD.find('input').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            parentD.find('input').val(0);
        }
    })

    $(document).on("click",".minicart-qty-btn-j",function(e){
        $(this).attr("disabled","true");
        var cartid = $(this).data('itemid');
        var parentD = $(this).parent()
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        // Get its current value
        var currentVal = parseInt(parentD.find('input').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            parentD.find('input').val(currentVal - 1);
            minicartChangeCartQty(cartid,currentVal - 1)
        } else {
            // Otherwise put a 0 there
            parentD.find('input').val(0);
        }
    })
    $(document).on('click','.minicart-select-gift-button',function(){
        getFreeGifts();
        $('#select-gift-modal').modal('show')

    });

    $(document).on('click','.minicart-remove-btn',function(){
        var cartid = $(this).data('id');
        $.ajax(
            {type: "POST",
                url: "/cart/change.js",
             	async:1,
             	cache:!1,
                data: "quantity=" + 0 + "&id=" + cartid,
                dataType: "json",
             	beforeSend: function() {
                  setTimeout(function(){ minicartAddMask();},1);
				},
                success: function(e) {
                    refreshMiniCart();
                 
                  // $(".self-loading").hide();
                },
                error: function(e, t) {
                  setTimeout(function(){ refreshMiniCart();minicartRemoveMask();},1);
                  // $(".self-loading").hide();
                }
            }
        )
    });